import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LetterWriteProfileComponent } from './letter-write-profile.component';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

@NgModule({
  declarations: [LetterWriteProfileComponent],
  imports: [
    CommonModule,
    BsDropdownModule.forRoot(),
  ],
  exports: [LetterWriteProfileComponent], 
})
export class LetterWriteProfileModule { }
